var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/widget/widget.tsx";
import React from 'react';
import { Text, IconButton } from 'soapbox/components/ui';
import HStack from 'soapbox/components/ui/hstack/hstack';
import Stack from 'soapbox/components/ui/stack/stack';

/** Title of a widget. */
const WidgetTitle = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    size: "xl",
    weight: "bold",
    tag: "h1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 3
    }
  }, title);
};
/** Body of a widget. */


const WidgetBody = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(Stack, {
    space: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 3
    }
  }, children);
};

/** Sidebar widget. */
const Widget = _ref3 => {
  let {
    title,
    children,
    onActionClick,
    actionIcon = require('@tabler/icons/arrow-right.svg'),
    actionTitle,
    action
  } = _ref3;
  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(WidgetTitle, {
    title: title,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }), action || onActionClick && /*#__PURE__*/React.createElement(IconButton, {
    className: "w-6 h-6 ml-2 text-black dark:text-white",
    src: actionIcon,
    onClick: onActionClick,
    title: actionTitle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(WidgetBody, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 7
    }
  }, children));
};

export default Widget;